import React, { useState } from "react";
import { Button } from "../../../components/atoms/Button/Button";
import { Spinner } from "../../../components/atoms/Spinner/Spinner";
import styles from "./UserPage.module.css";
import { useUsers } from "../../../features/admin/user/application/useUsers";
import { Pagination } from "../../../components/molecules/Pagination/Pagination";
import { TreeViewer } from "../../../components/organism/TreeViewer/TreeViewer";
import { Input } from "../../../components/atoms/Input/Input";
import { RiFileExcel2Line } from "react-icons/ri";
import {
  MdSearch,
  MdOutlineAccountTree,
  MdOutlineTableChart,
} from "react-icons/md";

import { getCandidateConfig } from "../../../../config/candidates";

export const UserPage: React.FC = () => {
  const {
    setFilter,
    userState,
    registrationState,
    handleNextPage,
    handlePrevPage,
    getUserTreeReferrals,
    applySearch,
    exportUsers,
  } = useUsers();

  const [viewMode, setViewMode] = useState<"table" | "tree">("table"); // 'table' o 'tree'

  const candidateName = process.env.REACT_APP_CANDIDATE_NAME || "default";
  const candidateConfig = getCandidateConfig(candidateName);
  const showTopics = candidateConfig.topics.length > 0;


  const handleSearch = () => {
    applySearch();
  };

  const handleTreeView = (userId: string | null) => {
    getUserTreeReferrals(userId);
    setViewMode(viewMode === "table" ? "tree" : "table");
  };

  const renderTableView = () => (
    <table className={styles.userTable}>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Celular</th>
          <th>Email</th>
          <th>Rango de Edad</th>
          <th>Genero</th>
          <th>Ubicación</th>
          <th>Referido por</th>
          <th>Total de Referidos</th>
          {showTopics && <th>Tema de Interes</th>}
          <th>Fecha de Registro</th>
          <th>Ver Árbol de Referidos</th>
        </tr>
      </thead>
      <tbody>
        {userState.users.length > 0 ? (
          userState.users.map((user) => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.phoneShow}</td>
              <td>{user.email}</td>
              <td>{user.ageRange}</td>
              <td>{user.gender === "male" ? "Masculino" : "Femenino"}</td>
              <td>
                {user.department.name} / {user.city.name}
              </td>
              <td>{user.referrerId?.name || ""}</td>
              <td>
                {"Directos: " +
                  user.referralCounts.direct +
                  " Indirectos: " +
                  user.referralCounts.indirect}
              </td>
              {showTopics && (
                  <td>
                    {
                      registrationState.topicsInterest.find(
                        (topic) => topic.id === user.topicInterest
                      )?.name
                    }
                  </td>
              )}
              <td>{user.createdAt.toLocaleString()}</td>
              <td>
                <Button
                  color="primary"
                  onClick={() => handleTreeView(user.id)}
                  type="button"
                >
                  Ver Árbol de Referidos
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={showTopics ? 11 : 10} className={styles.noResults}>
              No se encontraron usuarios.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );

  const renderTreeView = () => <TreeViewer data={userState.usersTree} />;

  return (
    <div className={styles.userPageContainer}>
      <div className={styles.header}>
        <h1>Gestión de Usuarios</h1>
        <div className={styles.controls}>
          <div className="flex gap-4 w-[50%] justify-end">
            <Input
              type="text"
              placeholder={`Ingresa 3 caracteres o más para buscar`}
              className={styles.searchInput}
              value={
                userState.paginationRequest.filters.find(
                  (f) => f.field === "search"
                )?.value || ""
              }
              onChange={(e) =>
                setFilter({ field: "search", value: e.target.value })
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
            <div>
              <Button color="accent" onClick={handleSearch} type="button">
                <MdSearch className="inline" size={20} />
              </Button>
            </div>
          </div>
          <div className="flex gap-4 w-[40%]">
            <Button
              color="primary"
              onClick={() => handleTreeView(null)}
              type="button"
            >
              {viewMode === "table" ? (
                <MdOutlineAccountTree className="inline mr-2" size={20} />
              ) : (
                <MdOutlineTableChart className="inline mr-2" size={20} />
              )}
              {viewMode === "table" ? "Ver Árbol" : "Ver Tabla"}
            </Button>
            <Button
              color="secondary"
              onClick={() => exportUsers()}
              type="button"
              disabled={userState.loading}
            >
              <RiFileExcel2Line className="inline mr-2" size={20} />
              Exportar a Excel
            </Button>
          </div>
        </div>
      </div>

      {userState.loading ? (
        <Spinner size="large" />
      ) : userState.error ? (
        <div className={styles.noResults}>{userState.error}</div>
      ) : viewMode === "table" ? (
        renderTableView()
      ) : (
        renderTreeView()
      )}

      {!userState.loading && viewMode === "table" && (
        <Pagination
          handlePrevPage={handlePrevPage}
          handleNextPage={handleNextPage}
          state={userState}
        />
      )}
    </div>
  );
};
